module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEXSURBVHgB7ZndDYIwFIUP6otvjsAIjuAo3YRugK9OwwiMwAi4AZakNaWh3rZQ7MP9kktM6LGfXkr4AdIQqjpVo6rJqVHvEziAWlW/IuGrQWeyyQwRMtmlbJm5LdIzUa332e3ssTPCkbkHZO6OlMCOdNYXy4ictHIddsT+pXVErsbynyWpEMaUkEnKnlAYRqjB+knOlE3ssg/JznO3ZlCbMEmukpW2u6EM3vNmYegZ6GtBCFRW2mMqhK2C3KvsO6bYVVYMLERxCRwXeyAnZ7llFCxEwUIULETBQhQsRMFCFCxEUZyQexv0d7hlFO5F/paL+S3wnWswLEThCjU4nsWcxT1BO6vNVdUDZfAyH574/RQ2d5l3J/gAklq31A+WlyAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bag.png
// module id = 1866
// module chunks = 0